<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerField, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerField v-slot="slotProps" :class="cn('flex items-center', props.class)" v-bind="forwardedProps">
        <slot v-bind="slotProps" />
    </DatePickerField>
</template>
